import React from "react";

import { InputAdornment, TextField } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import SortIcon from "@material-ui/icons/Sort";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Button from "@material-ui/core/Button";
import Switch from "@material-ui/core/Switch";
import Grid from "@material-ui/core/Grid";

export const SearchComponent = ({
  handleChange,
  onClick,
  onFilter,
  filter = false,
  gemeentes,
  categories,
  onFilterCategorie,
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedGem, setSelectedGem] = React.useState({});
  const [selectedCategories, setSelectedCategories] = React.useState({});

  React.useEffect(() => {
    if (gemeentes) {
      const initial = gemeentes?.reduce(
        (acc, gem) => ({ ...acc, [gem]: false }),
        {}
      );
      setSelectedGem(initial);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const toggleGem = (gemeente) => {
    const newState = { ...selectedGem, [gemeente]: !selectedGem[gemeente] };

    const filteredGemeentes = Object.keys(newState).map((gem) => {
      if (newState[gem]) {
        return gem;
      } else {
        return null;
      }
    });

    setSelectedGem(newState);
    onFilter(filteredGemeentes.filter((x) => x !== null));
  };

  const toggleCategorie = (categorie) => {
    const newState = {
      ...selectedCategories,
      [categorie]: !selectedCategories[categorie],
    };

    const filteredCategories = Object.keys(newState).map((cat) => {
      if (newState[cat]) {
        return cat;
      } else {
        return null;
      }
    });

    setSelectedCategories(newState);
    onFilterCategorie(filteredCategories.filter((x) => x !== null));
  };

  return (
    <div>
      <div
        style={{
          padding: 8,
          paddingLeft: 0,
          display: "flex",
          alignItems: "center",
        }}
      >
        {filter && (
          <>
            <Button
              aria-controls="simple-menu"
              aria-haspopup="true"
              onClick={handleClick}
            >
              <SortIcon
                style={{
                  padding: "8px",
                  margin: "0 8px",
                  border: "1px solid lightgray",
                  borderRadius: 5,
                }}
              />
            </Button>

            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              <Grid container>
                <Grid item xs={4}>
                  <MenuItem disabled>
                    <span style={{ width: 250 }}>Gemeente</span>
                  </MenuItem>
                  {gemeentes.map((gem, i) => (
                    <MenuItem onClick={() => toggleGem(gem)} key={i}>
                      <Switch checked={selectedGem[gem] || false} />
                      {gem[0].toUpperCase() + gem.slice(1)}
                    </MenuItem>
                  ))}
                </Grid>
                <Grid item xs={8}>
                  <MenuItem disabled>
                    <span style={{ width: 300 }}>Categorie</span>
                  </MenuItem>
                  {categories.sort().map((categorie, i) => (
                    <MenuItem
                      onClick={() => toggleCategorie(categorie)}
                      key={i}
                    >
                      <Switch checked={selectedCategories[categorie] || false} />
                      {categorie[0].toUpperCase() + categorie.slice(1)}
                    </MenuItem>
                  ))}
                </Grid>
              </Grid>
            </Menu>
          </>
        )}
        <TextField
          fullWidth
          id="outlined-search"
          label="Zoek Handelaar"
          type="search"
          variant="outlined"
          onChange={handleChange}
          onClick={onClick}
          InputProps={{
            endAdornment: (
              <InputAdornment>
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </div>
  );
};
